if (!customElements.get("subscription-radio")) {
  customElements.define(
    "subscription-radio",
    class SubscriptionRadio extends HTMLElement {
      constructor() {
        super();
        this.selectedFrequency = this.querySelector(".selected-frequency");
        this.sellingPlan = this.querySelector('input[name="selling_plan"]');
        this.radios = this.querySelectorAll(
          'input[type=radio][name="subscription-radio"]'
        );
        this.selectContainer = this.querySelector(
          ".subscription-radio__select"
        );
        this.select = this.querySelector('select[name="selling-plan-select"]');
        this.subscriptionSaving = this.querySelector(".subscription__saving");
        const productRoot =
          this.closest("[data-product]") || document.documentElement;
        this.form =
          this.closest('form[data-product-form]') ||
          this.closest("form") ||
          productRoot.querySelector('form[data-product-form]');
        this.variants = productRoot.querySelectorAll(
          "input[type=radio].variant-option"
        );
        if (this.form) {
          this.variants = this.form.querySelectorAll(
            "input[type=radio].variant-option"
          );
        }
        this.oneTimePrice = this.querySelector(".one-time__price");
        this.oneTimeCompare = this.querySelector(".one-time__compare");
        this.subscriptionPrice = this.querySelector(".subscription__price");
        this.subscriptionCompare = this.querySelector(".subscription__compare");
        this.onetimePer = productRoot.querySelectorAll(".per-one-time");
        this.subscriptionPer = productRoot.querySelectorAll(".per-subscription");

        this.attachEvents();
        if (this.select && this.select.options.length) {
          this.selectChange({ target: this.select });
        }
      }

      getSaveLabel() {
        return this.dataset.saveLabel || "Save";
      }

      formatFrequencyText(text) {
        if (!text) return "";
        return (
          '<span class="frequency-plan">' +
          text +
          "</span>" +
          '<span class="frequency-perk">Then 15% off every order — starting with your 3rd</span>'
        );
      }

      getProductRoot() {
        return this.closest("[data-product]") || document;
      }

      getProductJson() {
        const root = this.getProductRoot();
        const el = root.querySelector(
          'script[type="application/json"][data-product-json], script[data-product-json]'
        );
        if (!el || !el.textContent) return null;
        try {
          return JSON.parse(el.textContent.trim());
        } catch (e) {
          return null;
        }
      }

      getCurrentVariantId() {
        const root = this.form || this.getProductRoot();
        const checkedVariant = root.querySelector("input.variant-option:checked");
        if (
          checkedVariant &&
          checkedVariant.dataset &&
          checkedVariant.dataset.variantId
        ) {
          return checkedVariant.dataset.variantId;
        }
        const idInput = root.querySelector(
          'form[data-product-form] input[name="id"], input[name="id"][data-product-select], input[name="id"]'
        );
        return idInput && idInput.value ? idInput.value : "";
      }

      getCheckedVariantOption() {
        const root = this.form || this.getProductRoot();
        return root.querySelector("input.variant-option:checked");
      }

      getSelectedPlanId() {
        const selectValue = this.select ? this.select.value : "";
        const hiddenValue = this.sellingPlan && this.sellingPlan.value
          ? this.sellingPlan.value
          : "";
        return hiddenValue || selectValue || "";
      }

      formatMoney(cents) {
        if (typeof cents !== "number" || Number.isNaN(cents)) {
          return "";
        }
        if (
          typeof window.themeCurrency !== "undefined" &&
          window.themeCurrency.formatMoney &&
          window.theme &&
          window.theme.moneyFormat
        ) {
          return window.themeCurrency.formatMoney(
            cents,
            window.theme.moneyFormat
          );
        }
        return "$" + (cents / 100).toFixed(2);
      }

      findAllocation(product, variantId, planId) {
        if (!product || !variantId || !planId) return null;
        const variant = product.variants.find(
          (v) => String(v.id) === String(variantId)
        );
        if (!variant || !variant.selling_plan_allocations) return null;
        return variant.selling_plan_allocations.find(
          (a) => String(a.selling_plan_id) === String(planId)
        );
      }

      updateSavingFromSelectedOption() {
        if (!this.subscriptionSaving || !this.select) return;
        const opt = this.select.selectedOptions[0];
        if (!opt) {
          this.subscriptionSaving.textContent = "";
          this.subscriptionSaving.hidden = true;
          return;
        }
        const type = (opt.dataset.type || "").trim();
        const adjRaw = opt.dataset.adjustment;
        const adj =
          adjRaw !== undefined && adjRaw !== "" ? Number(adjRaw) : NaN;
        const save = this.getSaveLabel();

        if (type === "percentage" && !Number.isNaN(adj)) {
          this.subscriptionSaving.textContent = save + " " + adj + "%";
          this.subscriptionSaving.hidden = false;
          return;
        }
        if (type === "fixed_amount" && !Number.isNaN(adj)) {
          this.subscriptionSaving.textContent =
            save + " " + this.formatMoney(adj);
          this.subscriptionSaving.hidden = false;
          return;
        }
        this.subscriptionSaving.textContent = "";
        this.subscriptionSaving.hidden = true;
      }

      updatePriceFromAllocationOrFallback() {
        const product = this.getProductJson();
        const variantId = this.getCurrentVariantId();
        const planId = this.getSelectedPlanId();
        const alloc = this.findAllocation(product, variantId, planId);

        if (alloc && alloc.price != null && this.subscriptionPrice) {
          this.subscriptionPrice.textContent = this.formatMoney(alloc.price);
        } else {
          const vo = this.getCheckedVariantOption();
          if (vo && vo.dataset.subscriptionPrice !== undefined) {
            this.subscriptionPrice.innerText = vo.dataset.subscriptionPrice;
          } else if (this.subscriptionPrice) {
            this.subscriptionPrice.textContent = "";
          }
        }

        if (this.subscriptionCompare) {
          if (alloc && alloc.compare_at_price != null) {
            this.subscriptionCompare.textContent = this.formatMoney(
              alloc.compare_at_price
            );
          } else {
            const vo = this.getCheckedVariantOption();
            if (vo && vo.dataset.subscriptionCompare !== undefined) {
              this.subscriptionCompare.innerText =
                vo.dataset.subscriptionCompare;
            } else {
              this.subscriptionCompare.textContent = "";
            }
          }
        }
      }

      refreshSubscriptionUi() {
        if (!this.isSubscriptionMode()) return;
        this.updateSavingFromSelectedOption();
        this.updatePriceFromAllocationOrFallback();
      }

      isSubscriptionMode() {
        const checked = this.querySelector(
          'input[name="subscription-radio"]:checked'
        );
        return checked && checked.value === "subscription";
      }

      attachEvents = () => {
        this.radios.forEach((radio) => {
          radio.addEventListener("change", this.radioChange);
        });

        this.variants.forEach((variant) => {
          variant.addEventListener("change", this.variantChange);
        });

        if (this.select) {
          this.select.addEventListener("change", this.selectChange);
        }
      };

      radioChange = (e) => {
        if (e.target.value === "subscription") {
          this.sellingPlan.value = this.select ? this.select.value : "";
          this.selectContainer.setAttribute("aria-hidden", false);
          this.onetimePer.forEach((ele) => {
            ele.setAttribute("aria-hidden", true);
          });
          this.subscriptionPer.forEach((ele) => {
            ele.setAttribute("aria-hidden", false);
          });
          e.target.closest(".sub-div").classList.remove("unselcted-border");
          e.target
            .closest(".sub-div")
            .nextElementSibling.classList.add("unselcted-border");

          this.sellingPlan.setAttribute(
            "selected-frequency-sub-text",
            this.select && this.select.selectedOptions[0]
              ? this.select.selectedOptions[0].text
              : ""
          );
          this.selectedFrequency.innerHTML = this.formatFrequencyText(
            this.sellingPlan.getAttribute("selected-frequency-sub-text")
          );
          this.refreshSubscriptionUi();
        } else {
          this.sellingPlan.value = "";
          this.selectContainer.setAttribute("aria-hidden", true);
          this.subscriptionPer.forEach((ele) => {
            ele.setAttribute("aria-hidden", true);
          });
          this.onetimePer.forEach((ele) => {
            ele.setAttribute("aria-hidden", false);
          });
          e.target.closest(".one-div").classList.remove("unselcted-border");
          e.target
            .closest(".one-div")
            .previousElementSibling.classList.add("unselcted-border");
          this.selectedFrequency.textContent = " One-time purchase";
        }
      };

      selectChange = (e) => {
        const selectEl = e.target;
        if (!selectEl || selectEl.tagName !== "SELECT") return;

        const checked = this.querySelector(
          'input[name="subscription-radio"]:checked'
        );
        if (!checked || checked.value !== "subscription") {
          return;
        }

        this.sellingPlan.value = selectEl.value;
        const opt = selectEl.selectedOptions[0];
        if (opt) {
          this.sellingPlan.setAttribute(
            "selected-frequency-sub-text",
            opt.text
          );
          this.selectedFrequency.innerHTML = this.formatFrequencyText(
            opt.text
          );
        }
        this.refreshSubscriptionUi();
      };

      variantChange = (e) => {
        if (e.target.dataset.price !== undefined) {
          this.oneTimePrice.innerText = e.target.dataset.price;
        } else {
          this.oneTimePrice.innerText = "";
        }

        if (e.target.dataset.compareAtPrice !== undefined) {
          this.oneTimeCompare.innerText = e.target.dataset.compareAtPrice;
        } else {
          this.oneTimeCompare.innerText = "";
        }
 
        
        if (e.target.dataset.subscriptionPrice !== undefined) {
          this.subscriptionPrice.innerText = e.target.dataset.subscriptionPrice;
        } else {
          this.subscriptionPrice.innerText = "";
        }

        if (e.target.dataset.subscriptionCompare !== undefined) {
          this.subscriptionCompare.innerText =
            e.target.dataset.subscriptionCompare;
        } else {
          this.subscriptionCompare.innerText = "";
        }
        // inweave@_01--------
        if (this.isSubscriptionMode()) {
          this.updateSavingFromSelectedOption();
          this.updatePriceFromAllocationOrFallback();
        }
      };
    }
  );
}
